<template>
  <section class="section-pay w-full max-w-[1600px] mx-auto px-140 min-h-607 pt-120">
    <div class="w-full text-center mb-80">
      <p class="text-5xl text-black font-bold">{{ $t('lang.question1') }}</p>
    </div>
    <el-collapse v-model="activeNames"  class="w-full text-left mt-50">
      <el-collapse-item name="1">
        <template slot="title">
          <span class="text-2xl text-black font-bold mb-30">{{ $t('lang.question2') }}</span>
        </template>
        <div class="text-1xl text-black mb-20">{{ $t('lang.question3') }}</div>
        <div class="text-1xl text-black">{{ $t('lang.question4') }}</div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <span class="text-2xl text-black font-bold mb-30">{{ $t('lang.question5') }}</span>
        </template>
        <div class="text-1xl text-black mb-20">{{ $t('lang.question6') }}</div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <span class="text-2xl text-black font-bold mb-30">{{ $t('lang.question7') }}</span>
        </template>
        <div class="text-1xl text-black mb-20">{{ $t('lang.question8') }}</div>
      </el-collapse-item>
      <el-collapse-item name="4">
        <template slot="title">
          <span class="text-2xl text-black font-bold mb-30">{{ $t('lang.question9') }}</span>
        </template>
        <div class="text-1xl text-black mb-20">{{ $t('lang.question10') }}</div>
      </el-collapse-item>
    </el-collapse>
  </section>
</template>

<script>
export default {
  name: "sectionPay",

  data() {
    return {
      activeNames: ["1", "2", "3", "4"]
    };
  },

  mounted() {},

  methods: {}
};
</script>


<style>
.el-collapse{
  border: none;
}
.el-collapse-item{
  padding: 30px 0;
}
.el-collapse-item__arrow {
  color: #FF7800;
  font-size: 16px;
  font-weight: bold;
}
</style>